import React, { useEffect, useRef, useState } from "react";
import useCurrentUserAccount from "../../hooks/data/queries/useCurrentUserAccount";
import { getAdyenPlatformExperience } from "../../services/adyenServices";
import { useParams } from "react-router-dom";
import { DisputesOverview } from "@adyen/adyen-platform-experience-web";
import Button from "../../components/Button";
import Input from "../../components/Input";

const displayDisputes: boolean =
  (process.env.REACT_APP_FF_DISPLAY_DISPUTES?.toLowerCase() ?? "true") ===
  "true";

type DisputesParams = { accountHolderCode: string };

function Disputes(): JSX.Element {
  const { accountHolderCode: accountHolderCodeParam } =
    useParams<DisputesParams>();
  const { data: currentUserAccountData } = useCurrentUserAccount();
  const [selectedAccountHolderCode, setSelectedAccountHolderCode] =
    useState<string>("");
  const currentAccountHolderCode =
    accountHolderCodeParam || selectedAccountHolderCode;
  const disputeOverviewRef = useRef<HTMLDivElement | null>(null);
  const showComponent =
    currentUserAccountData?.type === "CSR" && displayDisputes;

  async function mountDisputeOverviewComponent(node: HTMLElement) {
    const disputeOverview = new DisputesOverview({
      core: await getAdyenPlatformExperience(currentAccountHolderCode || "", [
        "Disputes Component: Manage",
      ]),
    });
    disputeOverview.mount(node);
  }

  useEffect(() => {
    mountDisputeOverviewComponent(disputeOverviewRef.current as HTMLElement);
  });

  function showDisputes(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formElements = form.elements as typeof form.elements & {
      accountHolderCode: HTMLInputElement;
    };
    if (formElements.accountHolderCode) {
      setSelectedAccountHolderCode(formElements.accountHolderCode.value);
    }
  }

  if (!showComponent) return <></>;

  return (
    <>
      {!accountHolderCodeParam && (
        <form onSubmit={showDisputes}>
          <div className="my-8 flex gap-x-2 px-6">
            <Input
              id="accountHolderCode"
              label="Account Holder"
              className="w-48"
            />
            <Button size="sm" type="submit">
              Show
            </Button>
          </div>
        </form>
      )}
      {currentAccountHolderCode && (
        <div className="dispute-overview" ref={disputeOverviewRef} />
      )}
    </>
  );
}

export default Disputes;
